// 首页
import homeManage from '@/views/webViews/views/homePageComponents/locale/zh-CN';

export default {
  'oldOfficialSite': '旧版官网',
  'homeManage.infoPlatform': '信息平台',
  'homeManage.email': '邮箱登录',
  'placeholder': '输入关键词搜索...',

  'TotalS': '共',
  'stripS': '条',
  'Goto': '前往',
  'pageS': '页',
  ...homeManage,
};
